import { memo } from "react";
import { Gavel } from "lucide-react";
import MobilePageHeader from "@/components/layout/MobilePageHeader";

interface MobileHeaderProps {
  onRefresh: () => void;
  isRefreshing: boolean;
}

const MobileHeader = memo(({ onRefresh, isRefreshing }: MobileHeaderProps) => {
  return (
    <MobilePageHeader
      title="OPAuctions"
      icon={<Gavel size={20} className="text-foreground" />}
      onRefresh={onRefresh}
      isRefreshing={isRefreshing}
    />
  );
});

MobileHeader.displayName = "MobileHeader";

export default MobileHeader;
